module.exports = __webpack_public_path__ + "img/PM_A03_back_en.3a420c19.png";